module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Chair#1-02198a10f4cc9c9a505c32eb98e78f5b32de36b0d0bd19df719f3f5af2a0338a.svg";